/**
 Author - Muhamed Afsal
 Git - https://bitbucket.org/mohdafsal/
 **/

import Recommended from "./Recommended";

export default Recommended;
